import { render, staticRenderFns } from "./privacyPolicy.vue?vue&type=template&id=2a24118a&scoped=true"
import script from "./privacyPolicy.vue?vue&type=script&lang=js"
export * from "./privacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./privacyPolicy.vue?vue&type=style&index=0&id=2a24118a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a24118a",
  null
  
)

export default component.exports